<template>
  <div>
    <v-card :height="cardHeight">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-subtitle>{{ subtitle }}</v-card-subtitle>
      <v-card-text>
        <VueApexCharts
          :width="width"
          :type="type"
          :options="options"
          :series="series"
          :height="`${parseInt(cardHeight) - 80}px`"
        ></VueApexCharts>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  name: "statistics-chart-card",
  components: { VueApexCharts },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
    width: {
      type: String,
      required: false,
      default: "100%",
    },
    type: {
      type: String,
      required: true,
    },
    series: {
      type: Array,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    cardHeight: {
      type: String,
      required: false,
      default: "400px",
    },
  },
};
</script>
